/**
 * Width for SuggestBoxWrapper (or similar) around {@link ReactDatePicker}:
 * default input is 6.75rem (~108px) + a little room for borders/padding.
 */
export const DATE_PICKER_SUGGEST_BOX_WIDTH_PX = 114;
/**
 * Width for wrappers around {@link ReactDateTimePicker} (date + time on one line).
 * Default input is 14rem; this keeps the control readable in sentence layouts.
 */

export const DATE_TIME_PICKER_SUGGEST_BOX_WIDTH_PX = 220;